(function () {
  'use strict';
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.__moduloIngInit) return;
    section.__moduloIngInit = true;

    var tablist = section.querySelector('.modulo-ing__tabs');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('.modulo-ing__tab'));
    var cards = section.querySelectorAll('.modulo-ing__card');
    var panels = section.querySelectorAll('.modulo-ing__panel');
    if (tabs.length < 2) return;

    var autoplay = section.getAttribute('data-autoplay') === '1';
    var interval = parseInt(section.getAttribute('data-interval'), 10) || 6;
    var current = 0;
    var timer = null;
    var paused = false;

    function toggle(list, idx, setHidden) {
      for (var i = 0; i < list.length; i++) {
        var on = i === idx;
        list[i].classList.toggle('is-active', on);
        if (setHidden) list[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
    }

    function swap(next, focusTab) {
      if (next < 0 || next >= tabs.length || next === current) {
        if (focusTab && tabs[next]) tabs[next].focus();
        return;
      }
      current = next;
      for (var i = 0; i < tabs.length; i++) {
        var on = i === next;
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[i].tabIndex = on ? 0 : -1;
      }
      toggle(cards, next, true);
      toggle(panels, next, true);
      if (focusTab && tabs[next]) tabs[next].focus();
    }

    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function start() {
      if (!autoplay || REDUCE) return;
      stop();
      timer = window.setInterval(function () {
        if (!paused) swap((current + 1) % tabs.length, false);
      }, interval * 1000);
    }
    function restart() { if (autoplay && !REDUCE) start(); }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { swap(i, false); restart(); });
    });

    /* Roving tabindex — Arrow / Home / End move focus and activate. */
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var n = tabs.length;
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (current + 1) % n;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (current - 1 + n) % n;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = n - 1;
        if (next !== null) { e.preventDefault(); swap(next, true); restart(); }
      });
    }

    if (autoplay && !REDUCE) {
      section.addEventListener('mouseenter', function () { paused = true; });
      section.addEventListener('mouseleave', function () { paused = false; });
      section.addEventListener('focusin', function () { paused = true; });
      section.addEventListener('focusout', function () { paused = false; });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { threshold: 0.25 });
        io.observe(section);
      } else {
        start();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
    }
  }

  function bootstrap() {
    var els = document.querySelectorAll('[data-modulo-ing]');
    for (var i = 0; i < els.length; i++) initSection(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Re-init when a section is (re)loaded in the theme editor. */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-modulo-ing]')) { initSection(t); return; }
    var el = t.querySelector && t.querySelector('[data-modulo-ing]');
    if (el) initSection(el);
  });
})();
